import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/utils/api';

export function useStartMode() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');

  const refresh = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await axios.get(`${API}/start-mode/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  const celebrateFirstLead = useCallback(async () => {
    if (!token) return;
    try {
      await axios.post(`${API}/start-mode/celebrate-first-lead`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      refresh();
    } catch { /* silent */ }
  }, [token, refresh]);

  return {
    startMode: data?.start_mode ?? false,
    reason: data?.reason,
    recommendedAction: data?.recommended_action,
    leadsCount: data?.leads_count ?? 0,
    groupsCount: data?.groups_count ?? 0,
    postsPublished: data?.posts_published ?? 0,
    photoCount: data?.photo_count ?? 0,
    hasProfile: data?.has_profile ?? false,
    newPostReady: data?.new_post_ready ?? false,
    daysSincePost: data?.days_since_post,
    hasAnyPost: data?.has_any_post ?? false,
    feedbackLoopActive: data?.feedback_loop_active ?? false,
    hoursSinceFirstPost: data?.hours_since_first_post,
    feedbackMessage: data?.feedback_message,
    readinessScore: data?.readiness_score ?? 0,
    readinessMissing: data?.readiness_missing ?? [],
    firstLeadCelebrated: data?.first_lead_celebrated ?? true,
    firstLead: data?.first_lead ?? null,
    returnTriggerActive: data?.return_trigger_active ?? false,
    hoursAway: data?.hours_away ?? 0,
    lastVisitAt: data?.last_visit_at ?? null,
    responseProfileComplete: data?.response_profile_complete ?? true,
    loading,
    refresh,
    celebrateFirstLead,
  };
}
